import StoryText from './case-story-items/story-text';
import StoryImage from './case-story-items/story-image';

import {
  TYPE_TEXT,
  TYPE_IMAGE,
  TYPE_STORY
} from '../../utils/case-types';

export default class CaseStory {
  constructor(data) {
    this.title = null;
    this.items = [];
    this.type = TYPE_STORY;
    // Initialize data
    if (data) {
      Object.assign(this, {
        title: data.Title,
        items: CaseStory.setItemStory(data)
      });
    }
  }

  static setItemStory(data) {
    const ItemsStory = [];
    if (data.Items) {
      data.Items.forEach((element) => {
        const itemType = element.Type.Id;
        switch (itemType) {
          case TYPE_TEXT:
            ItemsStory.push(new StoryText(element));
            break;
          case TYPE_IMAGE:
            ItemsStory.push(new StoryImage(element));
            break;
          default:
            break;
        }
      });
      return ItemsStory;
    }
    return [];
  }
}



// WEBPACK FOOTER //
// src/entities/case/case-story.js